import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=cdc7e9ae&scoped=true"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"
import style0 from "./Course.vue?vue&type=style&index=0&id=cdc7e9ae&prod&lang=scss&scoped=true"
import style1 from "./Course.vue?vue&type=style&index=1&id=cdc7e9ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc7e9ae",
  null
  
)

export default component.exports